import React from 'react'
import { LeftTextRightPicture, Quote, goldColour } from './Home'
import BlueButton from '../components/BlueButton'
import { useNavigate } from 'react-router-dom'
import T from '../components/Translation'

const AboutMe = () => {
  const navigate = useNavigate();
  return (
    <div className="about-me">
      <div style={{padding: "20px", display: "flex", justifyContent: "flex-start"}}>
        <BlueButton home />
      </div>
      <LeftTextRightPicture 
        imageSource="/homePictures/mikeAbout.png"
        title="Michael Bianco"
      >
        <div style={{padding: "20px", fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
        <T obj = {{
          en: <>  
            As a hypnotherapist and musician, I've dedicated my career to understanding 
            how we can accelerate personal growth, emotional and behavioural transformation. Through my work with <span style={{color: goldColour}}><b>reMind</b></span>, 
            I've combined evidence-based psychological principles with the transformative power of music.
            <br/><br/>
            I believe that the most important ingredient for succeeding in today's fast-paced, ever-transforming environment 
            is flexibility and adaptability to change. Through years of study and practice, I've learnt 
            and integrated concepts of self-hypnosis, Taiji, Chinese medicine, parts work, and Ericksonian techniques.
            <br/><br/>
            From 2020 to 2022, I hosted SoulBrunch, a live streaming program where we created songs and 
            affirmations collaboratively with our community. This unique approach allowed us to address 
            universal emotional challenges while providing powerful tools for personal transformation.
            <br/><br/>
            Today, through <span style={{color: goldColour}}><b>reMind</b></span>, we continue to help people worldwide by providing 
            music combined with positive affirmations. Our approach makes personal growth 
            more engaging and effective by leveraging the emotional impact of music to create lasting change.
            <br/><br/>
          </>,
          it: <>
            Come ipnoterapeuta e musicista, ho dedicato la mia carriera a comprendere 
            come possiamo accelerare la crescita personale e la trasformazione emotiva e comportamentale. Attraverso il mio lavoro con <span style={{color: goldColour}}><b>reMind</b></span>, 
            ho combinato principi psicologici con il potere trasformativo della musica.
            <br/><br/>
            Credo che l'ingrediente più importante per avere successo nell'ambiente frenetico e in continua evoluzione di oggi 
            sia la flessibilità e la capacità di adattarsi al cambiamento. In anni di studio e pratica, mi sono concentrato ad imparare
            ed integrare concetti di autoipnosi, Taiji, medicina cinese, parts work e tecniche ericksoniane.
            <br/><br/>
            Dal 2020 al 2022, ho condotto SoulBrunch, un programma in diretta streaming in cui abbiamo creato canzoni e 
            affermazioni in collaborazione con gli ascoltatori. Questo approccio unico ci ha permesso di affrontare 
            sfide emotive universali offrendo strumenti potenti per la trasformazione personale.
            <br/><br/>
            Oggi, attraverso <span style={{color: goldColour}}><b>reMind</b></span>, continuiamo ad aiutare persone in tutto il mondo fornendo 
            musica integrata ad affermazioni positive. Il nostro approccio rende la crescita personale 
            più coinvolgente ed efficace, sfruttando l'impatto emotivo della musica per creare cambiamenti duraturi.
            <br/><br/>
          </>
        }}/>
        </div>
      </LeftTextRightPicture>

      <div className="blue-background" style={{padding: "40px 0"}}>
        <Quote dark author="Michael Bianco" fontSize="24px">
        <T obj = {{
            en: <>  
              Music has the unique ability to bypass our rational minds and speak directly to our emotions. <br/>
              When we combine this with intentional psychological techniques, we create a powerful catalyst for change.
            </>,
            it: <>
              La musica ha la straordinaria capacità di bypassare la nostra mente razionale e di parlare direttamente alle nostre emozioni. <br/>
              Quando la combiniamo con tecniche psicologiche mirate, creiamo un potente catalizzatore per il cambiamento.
            </>
          }}/>
        </Quote>
      </div>

      <div style={{padding: "40px"}}>
        <div style={{ margin: "0 auto"}}>
          <h3 style={{marginBottom: "20px"}}>
          <T obj = {{
              en: <>Professional Background</>,
              it: <>Esperienza Professionale</>
            }}/>
          </h3>
          <T obj = {{
              en: <>  
                My journey in alternative therapies began in 2008. After studying acupuncture with Dr. Salvatore Auriemma 
                and assisting him for two years, I completed my studies at the College of Chinese Medicine, qualifying in 
                orthopaedic acupuncture, Korean hand, spinal, ear, and cosmetic acupuncture.
                <br/><br/>
                I later graduated in advanced hypnotherapy at the Surrey College of Clinical Hypnotherapy & Psychotherapy, 
                obtaining certifications in EFT, EMDR plus, NLP, positive psychology, solution-focused therapy, and timeline therapy. 
                I also completed the intermediate level of Ericksonian Approaches to Brief Hypnotic Psychotherapy at the 
                Erickson Foundation.
                <br/><br/>
                In recent years, I've been practicing Yang-style Taiji at The 9 Cloud Studio school in Shanghai, learning 
                from a prestigious lineage including Patrick Kelly, Master Huang Xingxian, Cheng Manqing, and Yang Chengfu. 
                This practice goes beyond physical, emotional, and mental centers, offering a path to spiritual realization 
                through using the body as a gym for the mind to grow and deepen.
                <br/><br/>
              </>,
              it: <>
                Il mio percorso nelle terapie alternative è iniziato nel 2008. Dopo aver studiato agopuntura con il Dr. Salvatore Auriemma 
                e averlo assistito per due anni, ho completato gli studi presso il College of Chinese Medicine, qualificandomi in 
                agopuntura ortopedica, della mano coreana, spinale, auricolare e cosmetica.
                <br/><br/>
                Successivamente, mi sono diplomato in ipnoterapia presso il Surrey College of Clinical Hypnotherapy & Psychotherapy, 
                ottenendo qualifiche in EFT, EMDR plus, NLP, psicologia positiva, terapia focalizzata sulla soluzione e timeline therapy. 
                Ho inoltre completato il livello intermedio degli Approcci Ericksoniani alla Psicoterapia Ipnotica Breve presso la 
                Erickson Foundation.
                <br/><br/>
                Negli ultimi anni, ho praticato il Taiji stile Yang presso la scuola The 9 Cloud Studio di Shanghai, apprendendo 
                da una prestigiosa linea di maestri tra cui Patrick Kelly, Maestro Huang Xingxian, Cheng Manqing e Yang Chengfu. 
                Questa pratica va oltre gli aspetti fisici, emotivi e mentali, offrendo un percorso di realizzazione spirituale, 
                utilizzando il corpo come una palestra per la mente per crescere e approfondire.
                <br/><br/>
              </>
            }}/>


          <h3 style={{marginBottom: "20px"}}>
            <T obj = {{
              en: <>My Approach</>,
              it: <>Il Mio Sistema</>
            }}/>
          </h3>
          <T obj = {{
              en: <>  
                Through the years, I've run numerous seminars 
                and one-to-one sessions focusing on improving communication skills, mental well-being, managing change, 
                stress, fear of heights, weight loss, self-esteem, and more.
                <br/><br/>
                Each <span style={{color: goldColour}}><b>reMind</b></span> song is carefully crafted to address specific emotional challenges 
                while providing practical solutions. The verses acknowledge and validate difficult experiences, 
                while the choruses offer powerful reframes and positive affirmations.
                <br/><br/>
                My mission is to introduce as many people as possible to the benefits of investing in personal development 
                and self-growth. By constantly learning, applying new skills and techniques, and making my own development 
                a priority, "tasting the pudding" myself first, maintaining a proactive and 
                ever-curious attitude and mindset.
                <br/><br/>
              </>,
              it: <>
                Nel corso degli anni, ho condotto numerosi seminari 
                e sessioni individuali focalizzate sul miglioramento delle capacità comunicative, del benessere mentale, sulla gestione 
                del cambiamento, dello stress, della paura dell'altezza, sulla perdita di peso, l'autostima e molto altro.
                <br/><br/>
                Ogni canzone di <span style={{color: goldColour}}><b>reMind</b></span> è attentamente progettata per affrontare sfide emotive specifiche 
                offrendo al contempo soluzioni pratiche. I versi riconoscono e convalidano esperienze difficili, 
                mentre i ritornelli offrono potenti reframe e affermazioni positive.
                <br/><br/>
                La mia missione è far conoscere a quante più persone possibili i benefici di investire nello sviluppo 
                e nella crescita personale. Continuando ad apprendere, applicare nuove competenze e tecniche, e facendo del mio 
                stesso sviluppo una priorità, mantenendo 
                un atteggiamento e una mentalità proattiva e curiosa.
                <br/><br/>
              </>
            }}/>

        </div>
      </div>
    </div>
  )
}

export default AboutMe
